<template>
    <div v-if="columnData" class="d-flex align-items-center text-nowrap">
        <div class="rating-section" @click="function () { if ((columnData.interest_level || columnData.overall_score) && columnData.permissions.indexOf('tracker-review-list') >= 0) $emit('action', {action: 'show-reviews', rowId: rowId})}">
            <a v-if="columnData.has_overall_score" class="mr-2">
                <div v-if="columnData.overall_score">
                    <b>Score: {{columnData.overall_score}} / {{columnData.max_overall_score}}</b>
                </div>
            </a>

            <div v-else class="rating">
                <span v-for="index in [1,2,3,4,5]" :key="index" :class="{'rating__current': columnData.interest_level >= index}"></span>
            </div>
            <span class="rating__result" v-if="columnData.reviews_count">{{columnData.reviews_count}}</span>
        </div>

        <a v-if="columnData.user_has_review && columnData.permissions.indexOf('tracker-review-own-edit') >= 0" class="link ml-3" @click="$emit('action', {action: 'edit-review', rowId: rowId})">Edit</a>
        <a v-if="!columnData.user_has_review && columnData.permissions.indexOf('tracker-review-add') >= 0" class="link ml-3" @click="$emit('action', {action: 'edit-review', rowId: rowId})">+ Add</a>
    </div>
</template>

<script>
export default {
    props: {
        columnData: {
            'reviews_count': Number,
            'interest_level': Number,
            'user_has_review': Boolean,
            'permissions': Boolean,
        },
        rowId: Number,
    },
}
</script>

<style scoped>

</style>
